module.exports = __webpack_public_path__ + "img/errorTriangle.039d106a.svg";